import * as THREE from "three";

export function canvasTexture({ title, subtitle = "", background = "#082d57", accent = "#ef5a17", width = 1024, height = 512 }) {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = background;
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "rgba(255,255,255,.055)";
  for (let x = -height; x < width; x += 90) {
    ctx.save(); ctx.translate(x, 0); ctx.rotate(-0.18); ctx.fillRect(0, 0, 30, height * 1.4); ctx.restore();
  }
  ctx.fillStyle = accent;
  ctx.fillRect(0, 0, 22, height);
  ctx.fillRect(60, 54, 116, 12);
  ctx.fillStyle = "#fff";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = `800 ${Math.round(height * 0.16)}px "Microsoft JhengHei", sans-serif`;
  ctx.fillText(title, width / 2, height * 0.48);
  if (subtitle) {
    ctx.fillStyle = "rgba(255,255,255,.72)";
    ctx.font = `500 ${Math.round(height * 0.05)}px sans-serif`;
    ctx.letterSpacing = "5px";
    ctx.fillText(subtitle, width / 2, height * 0.68);
  }
  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = 4;
  return texture;
}

export function stripeTexture(renderer) {
  const canvas = document.createElement("canvas");
  canvas.width = 512; canvas.height = 512;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#d8dad9"; ctx.fillRect(0, 0, 512, 512);
  ctx.strokeStyle = "#26333a"; ctx.lineWidth = 16;
  for (let x = -512; x < 1024; x += 56) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x - 380, 512); ctx.stroke(); }
  const texture = new THREE.CanvasTexture(canvas);
  texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(5, 5);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return texture;
}

export function labelSprite(text, color = "#082d57") {
  const canvas = document.createElement("canvas");
  canvas.width = 512; canvas.height = 128;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "rgba(255,255,255,.94)";
  ctx.roundRect(6, 6, 500, 116, 18); ctx.fill();
  ctx.fillStyle = color; ctx.textAlign = "center"; ctx.textBaseline = "middle";
  ctx.font = '700 42px "Microsoft JhengHei", sans-serif'; ctx.fillText(text, 256, 66);
  const material = new THREE.SpriteMaterial({ map: new THREE.CanvasTexture(canvas), transparent: true, depthTest: false });
  const sprite = new THREE.Sprite(material); sprite.scale.set(8, 2, 1); sprite.renderOrder = 20;
  return sprite;
}

export function metalMaterial(color = 0xc9cdd0) {
  return new THREE.MeshStandardMaterial({ color, metalness: 0.72, roughness: 0.3 });
}
